<template>
    <tab :index="tabIndex">
        <section class="sport-page not-wallet" :class="{'sport-not-login': !this.$store.state.user}">
            <b-container>
                <div class="container-sport flex-box">
                    <div class="sport-box" :class="{'sport-box--disabled': isMaintainEuro}">
                        <a href="javascript:void(0)" @click.prevent="onClick('/the-thao-chau-au')"  title="Thể Thao Châu Âu">
                            <div class="sport-item">
                                <div class="sport-layer text-left">
                                    <s-img class="show-pc" src="/assets/img/sports/player-e.png" alt="layer" />
                                    <s-img class="show-mb" src="/assets/img/sports/player-e-mb.png" alt="layer" />
                                </div>
                                <div class="sport-text">
                                    <s-img class="show-desktop" src="/assets/img/sports/sport-e.png" alt="bg" />
                                    <div class="text">
                                        <span class="button">CƯỢC NGAY</span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="sport-center">
                        <s-img src="/assets/img/sports/sport-line.png" alt="line" />
                    </div>
                    <div class="sport-box" :class="{'sport-box--disabled': isMaintainKsport}">
                        <a href="javascript:void(0)" @click.prevent="onClick('/ksport')" title="K-Sport">
                            <div class="sport-item">
                                <div class="sport-layer text-center">
                                    <s-img class="show-pc" src="/assets/img/sports/player-k.png" alt="layer" />
                                    <s-img class="show-mb" src="/assets/img/sports/player-k-mb.png" alt="layer" />
                                </div>
                                <div class="sport-text">
                                    <s-img class="show-desktop" src="/assets/img/sports/sport-k.png" alt="bg" />
                                    <div class="text">
                                        <span class="button button--green">CƯỢC NGAY</span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="sport-center line-2">
                        <s-img src="/assets/img/sports/sport-line.png" alt="line" />
                    </div>
                    <div class="sport-box" :class="{'sport-box--disabled': isMaintainAsia}">
                        <a class="sport-box__desktop" href="javascript:void(0)" @click.prevent="onClick('/the-thao-chau-a')" title="Thể Thao Châu Á">
                            <div class="sport-item">
                                <div class="sport-layer text-right">
                                    <s-img class="show-pc" src="/assets/img/sports/player-a.png" alt="layer" />
                                    <s-img class="show-mb" src="/assets/img/sports/player-a-mb.png" alt="layer" />
                                </div>
                                <div class="sport-text">
                                    <s-img class="show-desktop" src="/assets/img/sports/sport-a.png" alt="bg" />
                                    <div class="text">
                                        <span class="button">CƯỢC NGAY</span>
                                    </div>
                                </div>
                            </div>
                        </a>
                        <div class="sport-box__mobile">
                            <div class="sport-item">
                                <div class="sport-layer text-right">
                                    <s-img class="show-pc" src="/assets/img/sports/player-a.png" alt="layer" />
                                    <s-img class="show-mb" src="/assets/img/sports/player-a-mb.png" alt="layer" />
                                </div>
                                <div class="sport-text">
                                    <s-img class="show-desktop" src="/assets/img/sports/sport-a.png" alt="bg" />
                                    <div class="text">
                                        <div class="version">** Chọn phiên bản cược</div>
                                        <div class="sport-item-button icon">
                                            <a href="javascript:void(0)" @click.prevent="moveTo('/the-thao-chau-a')" title="Thể Thao Châu Á" class="button icon">
                                                <img src="/assets/img/icon-mobile.svg" loading="lazy" alt="mobile"/>
                                                Bản Mobile
                                            </a>
                                            <a href="javascript:void(0)" @click.prevent="moveTo('/the-thao-chau-a?ver=desktop')" title="Thể Thao Châu Á" class="button icon">
                                                <img src="/assets/img/icon-pc.svg" loading="lazy" alt="desktop"/>
                                                Bản PC
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-container>
        </section>
     <MaintainSportModal />
    </tab>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import tab from '~/components/tab.vue';
// eslint-disable-next-line import/no-unresolved
import MaintainSportModal from '~/components/desktop/dialogs/maintain-sport.vue';

export default {
    components: {
        tab,
        MaintainSportModal
    },
    props: ['data', 'tabIndex'],
    data() {
        return {
        };
    },
    computed: {
        isMaintainEuro() {
            return process.env.MAINTAIN_EURO === '1';
        },
        isMaintainAsia() {
            return process.env.MAINTAIN_ASIA === '1';
        },
        isMaintainKsport() {
            return process.env.MAINTAIN_KSPORT === '1';
        }
    },
    watch: {
    },
    methods: {
        moveTo(link) {
            // if (link === '/the-thao-chau-au') {
            //     this.$alert('Thể thao châu âu đang bảo trì. Quý khách vui lòng quay lại sau');
            //     return;
            // }
            if (this.$store.state.device === 'mobile') {
                this.$openLink(link, {
                    loginRequired: false,
                    newTab: true
                });
            } else {
                this.$openLink(link, {
                    loginRequired: false,
                    newTab: false
                });
            }
        },
        onClick(link) {
            switch (link) {
                case '/the-thao-chau-au':
                    if (this.isMaintainEuro) {
                        this.$bvModal.show('maintainSportModal');
                    } else {
                        this.moveTo(link);
                    }
                    break;
                case '/ksport':
                    if (this.isMaintainKsport) {
                        this.$bvModal.show('maintainSportModal');
                    } else {
                        this.moveTo(link);
                    }
                    break;
                case '/the-thao-chau-a':
                    if (this.isMaintainAsia) {
                        this.$bvModal.show('maintainSportModal');
                    } else {
                        this.moveTo(link);
                    }
                    break;
                default:
                    break;
            }
        }
    },
    mounted() {
        this.$nextTick(async () => {
            this.$opacity(350, '.sport-page');
        });
    }
};
</script>
